import { KeyofLocation } from "@pages/Assets/LocationProvisioning/const";
import { Location } from "@services/locations/types";

export const alwaysRequiredFields: KeyofLocation[] = [
  "name",
  "details.address1",
  "details.timeZone",
  "details.geoLocationAutomatic",
  "country",
  "city",
];

export const getRequiredFieldsDueToGeoLocationManual = (
  location?: Location
): KeyofLocation[] => {
  if (location?.details?.geoLocationAutomatic === false) {
    return ["latitude", "longitude"];
  }
  return [];
};
export const getAllRequiredFields = (location?: Location) =>
  [
    alwaysRequiredFields,
    getRequiredFieldsDueToGeoLocationManual(location),
  ].flat();
export const isRequired = (property: KeyofLocation) =>
  alwaysRequiredFields.includes(property);
